import { useRef, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const extOf = (n) => (n && n.includes(".") ? n.slice(n.lastIndexOf(".")) : "");
const baseOf = (n) => (n && n.includes(".") ? n.slice(0, n.lastIndexOf(".")) : n || "");

export const withExt = (newBase, original) => `${(newBase || "").trim() || baseOf(original)}${extOf(original)}`;

export const renamedFile = (file, name) => (name === file.name ? file : new File([file], name, { type: file.type }));

export function useFileNamePrompt() {
  const [state, setState] = useState(null);
  const resolver = useRef(null);
  const ask = (original, title = "Nome del file") => new Promise((resolve) => {
    resolver.current = resolve;
    setState({ original, title, value: baseOf(original) });
  });
  const close = (val) => { resolver.current?.(val); resolver.current = null; setState(null); };
  const dialog = (
    <Dialog open={!!state} onOpenChange={(o) => { if (!o) close(null); }}>
      <DialogContent className="max-w-md" data-testid="file-name-dialog">
        <DialogHeader>
          <DialogTitle>{state?.title}</DialogTitle>
          <DialogDescription>L'estensione {extOf(state?.original) || "originale"} viene mantenuta in automatico.</DialogDescription>
        </DialogHeader>
        <div className="flex items-center gap-2">
          <Input autoFocus data-testid="file-name-input" value={state?.value || ""}
            onChange={(e) => setState((s) => ({ ...s, value: e.target.value }))}
            onKeyDown={(e) => { if (e.key === "Enter") close(withExt(state.value, state.original)); }} />
          <span className="text-sm text-muted-foreground shrink-0">{extOf(state?.original)}</span>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => close(null)} data-testid="file-name-cancel">Annulla</Button>
          <Button onClick={() => close(withExt(state.value, state.original))} data-testid="file-name-confirm">Conferma</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
  return [ask, dialog];
}
